import {Component, inject, OnInit} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TranslatePipe} from "../../filters/translate.pipe";
import {LoaderOverlayComponent} from "../loader-overlay/loader-overlay.component";
import AngularFilterHelperService from "../../services/angular-filter-helper.service";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import $ from "jquery";

@Component({
    standalone: true,
    selector: 'modal-safety-survey-results',
    templateUrl: './modal-safety-survey-results.component.html',
    imports: [
        CommonModule, TranslatePipe, LoaderOverlayComponent
    ]
})
export class ModalSafetySurveyResultsComponent implements OnInit {
    private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
    private dialogRef = inject(MatDialogRef<ModalSafetySurveyResultsComponent>);
    private data = inject(MAT_DIALOG_DATA);

    vm: any = undefined;

    constructor() {
        this.vm = this;
    }

    ngOnInit() {
        Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
        var w: any = $(window).width();
        this.vm.isSmallSizeWindow = (w ? w <= 768 : false);
        this.vm.titleFontSize = this.vm.isSmallSizeWindow ? '16px' : '22px';
        this.vm.safetyGroupT = this.getSafetyGroupTitle(this.vm.safetyGroup);
        this.vm.safetyGroupTitle = this.vm.safetyGroupT;


        this.vm.close = this.close;
        this.vm.formatTranslation = this.formatTranslation;

    }

    getSafetyGroupTitle(safetyGroupType) {
        if (safetyGroupType === 'inclusion') {
            this.vm.inclusionSafetyDescription = true;
            return this.angularFilterHelperService.translate('Surveys.Inclusion_Safety_Title');
        } else if(safetyGroupType === 'learner') {
            this.vm.learnerSafetyDescription = true;
            return this.angularFilterHelperService.translate('Surveys.Learner_Safety_Title');
        } else if(safetyGroupType === 'contributor') {
            this.vm.contributorSafetyDescription = true;
            return this.angularFilterHelperService.translate('Surveys.Contributor_Safety_Title');
        } else if(safetyGroupType === 'challenger') {
            this.vm.challengerSafetyDescription = true;
            return this.angularFilterHelperService.translate('Surveys.Challenger_Safety_Title');
        }
    }

    close() {
        this.dialogRef.close(undefined);
    }

    formatTranslation(text: string): string {
        if (!text) return '';
        return text.replace(/<b>/g, '<strong>').replace(/<\/b>/g, '</strong>');
    }
}